import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-token-package-cancel',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './token-package-cancel.component.html',
  styleUrl: './token-package-cancel.component.css',
})
export class TokenPackageCancelComponent {
  constructor(private router: Router) {}

  goToDashboard(): void {
    const returnUrl = sessionStorage.getItem('tokenPurchaseReturnUrl') ?? '/my-garage';
    sessionStorage.removeItem('tokenPurchaseReturnUrl');
    sessionStorage.removeItem('tokenPurchaseExpectedCredits');
    this.router.navigateByUrl(returnUrl);
  }
}
